import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useModals from '../Modal/manager/useModal';
import {
  checkEmail,
  checkNumber,
  findImage,
  isEmpty,
  isPaymentTokenExpired,
} from 'utils/Utils';
import ReactSelect from 'react-select';
import { defaultCountryList } from 'app/pages/Payment/country';
import TermsModal from '../Modal/TermsModal';
import PrivacyPolicyModal from '../Modal/PrivacyPolicyModal';
import ErrorModal from '../Modal/ErrorModal';
import CardFormErrorModal from '../Modal/CardFormErrorModal';
import { useNavigate } from 'react-router-dom';
import KeyPad from '../keypad';
import { Credit3DsRequest } from '../TabCredit/types';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import { isMobile } from 'react-device-detect';
import { useMutation } from 'react-query';
import { innerSearch } from 'api/Api';
import ArrowPng from 'app/assets/image/common/arrow.png';
import { useMediaQuery } from 'react-responsive';

interface Credit3DsFormProps {
  previous: (e: any) => void;
  keypadToken: string;
  setLoading: (method: boolean) => void;
  brandList: string[];
  setPopup: (e: Window | null) => void;
  isUnique: boolean;
  handleClosed: (e) => void;
  isGlobal: boolean;
}

const Credit3DsForm = ({
  previous,
  keypadToken,
  setLoading,
  brandList,
  setPopup,
  isUnique,
  handleClosed,
  isGlobal,
}: Credit3DsFormProps) => {
  const refs = {
    firstKeypadRef: useRef<HTMLDivElement>(null),
    secondKeypadRef: useRef<HTMLDivElement>(null),
    expiryDateKeypadRef: useRef<HTMLDivElement>(null),
    cvcKeypadRef: useRef<HTMLDivElement>(null),
    lastKeypadRef: useRef<HTMLDivElement>(null),
    tab1Ref: useRef<HTMLDivElement>(null),
    emailRef: useRef<HTMLDivElement>(null),
  };

  const foucsTerms = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const { openModal } = useModals();
  const navigate = useNavigate();
  const { paymentState, setPaymentState, setShopifyState } = usePaymentState();
  const numberPattern = /^[0-9!@#$%^&*()\-=_+[\]{}|\\;:'",.<>/?]*$/;
  const [schemeCode, setSchemeCode] = useState('');

  const [familyName, setFamilyName] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [countryList, setCountryList] = useState<
    { value: string; label: string }[]
  >([]);
  const [selectCard, setSelectCard] = useState<'others' | 'unionpay' | 'amex'>(
    'others',
  );

  const [cardNumber, setCardNumber] = useState<string>('');
  // const [cardBinNum, setCardBinNum] = useState<string>('');
  const [isNoNameError, setNoNameError] = useState<boolean>(false);
  const [isCardNumberError, setCardNumberError] = useState<boolean>(false);
  const [isLastCardNumberError, setLastCardNumberError] =
    useState<boolean>(false);

  const [expirationDate, setExpirationDate] = useState<string>('');
  const [isExpirationDateError, setExpirationDateError] =
    useState<boolean>(false);
  const [cvccvv, setCvccvv] = useState<string>('');
  const [isCvccvvError, setCvccvvError] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [agreeCheck, setAgreeCheck] = useState<boolean>(false);
  const [AgreeCheckError, setAgreeCheckError] = useState<boolean>(false);
  //   const [cardParams, setCardParams] = useState(new CardParams());

  //validation state
  const [isNameEdit, setNameEdit] = useState<boolean>(false);
  const [isCardNumberEdit, setCardNumberEdit] = useState<boolean>(false);
  const [isLastCardNumberEdit, setLastCardNumberEdit] =
    useState<boolean>(false);
  const [isCardValueError, setCardValueError] = useState<boolean>(false);

  // 청구서 주소 관련 State
  const [address, setAddress] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [country, setCountry] = useState<string>('');
  const [zipCode, setZipCode] = useState<string>('');
  const [state, setState] = useState<string>('');
  const [phoneNum, setPhoneNum] = useState<string>('');

  // 청구서 주소 Error State
  const [isAddressError, setAddressError] = useState<boolean>(false);
  const [isCityError, setCityError] = useState<boolean>(false);
  const [isCountryError, setCountryError] = useState<boolean>(false);
  const [isZipCodeError, setZipCodeError] = useState<boolean>(false);
  const [isStateError, setStateError] = useState<boolean>(false);
  const [isPhoneNumError, setPhoneNumError] = useState<boolean>(false);
  const [isEmailError, setEmailError] = useState<boolean>(false);

  // 청구서 주소 Validation State
  const [isAddressEdit, setAddressEdit] = useState<boolean>(false);
  const [isCityEdit, setCityEdit] = useState<boolean>(false);
  const [isCountryEdit, setCountryEdit] = useState<boolean>(false);
  const [isZipCodeEdit, setZipCodeEdit] = useState<boolean>(false);
  const [isStateEdit, setStateEdit] = useState<boolean>(false);

  // 청구서 주소 Form Active
  const [iSBillInfoFormActive, setIBillInfoFormActive] = useState(false);

  const [isEncryptedFirstCardNumberError, setEncryptedFirstCardNumberError] =
    useState<boolean>(false);
  const [isEncryptedSecondCardNumberError, setEncryptedSecondCardNumberError] =
    useState<boolean>(false);
  const [lastCardNumber, setLastCardNumber] = useState<string>('');

  const [encryptedFirstCardNumber, setEncryptedFirstCardNumber] = useState({
    data: null,
    token: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encryptedSecondCardNumber, setEncryptedSecondCardNumber] = useState({
    data: null,
    token: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });
  const [encodedExpiryDateMonth, setEncodedExpiryDateMonth] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });
  const [encodedExpiryDateYear, setEncodedExpiryDateYear] = useState({
    data: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [encodedCVC, setEncodedCVC] = useState({
    data: null,
    token: null,
    hmac: null,
    coordType: 'PIN',
    shuffleType: 'RANDOM',
    encryptionType: 'AES128',
    length: 0,
  });

  const [credit3DsRequsetBody, setCredit3DsRequestBody] =
    useState<Credit3DsRequest>();
  const [open, setOpen] = useState<boolean>(false);
  const isMobileSize = useMediaQuery({ maxWidth: 767 });

  let checkPopupTimer;

  useEffect(() => {
    setCountryList(
      defaultCountryList.map(item => ({ value: item, label: t(`${item}`) })),
    );
  }, [i18n.language]);

  useEffect(() => {
    setAgreeCheckError(false);
  }, [agreeCheck]);

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(paymentState.tid), {
    onSuccess: data => {
      setLoading(false);
      if (data.data.returnUrl.includes('shopifyConfirm')) {
        setShopifyState(data.data.response);
        navigate('/shopifyConfirm');
      } else {
        // InnerSearch 결과처리
        payResult(data);

        // 결과 상태가 없을경우 예외처리
        if (
          data.data.response.resultStatus === null ||
          data.data.response.resultStatus === undefined
        ) {
          navigate('/error');
        }
      }
    },
    onError: error => {
      setLoading(false);
      navigate('/error');
    },
  });

  // 결제 결과 PaymentState set 및 결과화면 처리
  const payResult = data => {
    // 결과 상태
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();

    // InnerSearch 결과 값 PaymentState 설정
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      billKey: data.data.response.billKey,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));

    // Status에 따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  const onChangeCardNumber = e => {
    const value = e.target.value;
    if (value.length === 0) {
      setCardNumber('');
      return;
    }
    //숫자 외 입력 못하도록 변경
    const isNumber = checkNumber(value.charAt(value.trim().length - 1));
    if (isNumber) {
      setCardNumber(e.target.value);
    }

    setCardNumberEdit(true);

    if (value.length === 4) {
      const nextRef = document.querySelectorAll('div.input.firstKeypad')[0]
        .children[1] as HTMLElement;
      if (nextRef) {
        nextRef.focus();
        nextRef.click();
      }
    }
  };

  const focusCardNumber = e => {
    if (refs.tab1Ref.current) {
      refs.tab1Ref.current.scrollTop = 90;
    }
  };

  const onChangeLastCardNumber = useCallback(
    e => {
      const value = e.target.value;
      if (value.length === 0) {
        setLastCardNumber('');
        return;
      }
      //숫자 외 입력 못하도록 변경
      const isNumber = checkNumber(value.charAt(value.trim().length - 1));
      if (isNumber) {
        setLastCardNumber(e.target.value);
      }

      setLastCardNumberEdit(true);

      if (value.length === 6) {
        const nextRef = document.querySelectorAll(
          'div.input.expiryDateMonth',
        )[0].children[1] as HTMLElement;
        if (nextRef) {
          nextRef.focus();
          nextRef.click();
        }
        if (refs.tab1Ref.current) {
          refs.tab1Ref.current.scrollTop = 200;
        }
      }
    },
    [lastCardNumber],
  );

  const clickMoreButton = e => {
    e.preventDefault();
    setIBillInfoFormActive(prevState => !prevState);
  };

  const clickFoldButton = e => {
    e.preventDefault();
    setIBillInfoFormActive(prevState => !prevState);

    setAddress('');
    setCity('');
    setCountry('');
    setZipCode('');
    setState('');
    setPhoneNum('');
  };

  const handleTermsOrPrivacy = content => {
    if (content === 'SERVICE') {
      openModal(TermsModal, {
        onSubmit: () => {},
      });
    } else {
      openModal(PrivacyPolicyModal, {
        onSubmit: () => {},
      });
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Enter 키의 기본 동작을 중지시킴
    }
  };

  const openInputError = () => {
    openModal(CardFormErrorModal, {
      error: t('card_input_error2'),
      message: t('card_input_error_msg'),
    });
  };

  const openBillingError = () => {
    openModal(ErrorModal, {
      message: t('billing_input_error'),
    });
  };

  const clickPay = e => {
    e.preventDefault();

    // 이름, 성 체크
    // if (isEmpty(familyName) || isEmpty(name)) {
    //   setNoNameError(true);
    //   openInputError();
    //   return;
    // }
    // setNoNameError(false);

    if (cardNumber.length < 4) {
      setCardNumberError(true);
      openInputError();
      return;
    }
    setCardNumberError(false);
    setCardValueError(false);

    if (encryptedFirstCardNumber.length < 4) {
      setEncryptedFirstCardNumberError(true);
      openInputError();
      return;
    }

    setEncryptedFirstCardNumberError(false);

    if (encryptedSecondCardNumber.length < 4) {
      setEncryptedSecondCardNumberError(true);
      openInputError();
      return;
    }

    setEncryptedSecondCardNumberError(false);

    if (lastCardNumber.length < 3 || lastCardNumber.length > 6) {
      setLastCardNumberError(true);
      openInputError();
      return;
    }

    if (selectCard !== 'amex' && lastCardNumber.length < 4) {
      setLastCardNumberError(true);
      openInputError();
      return;
    }

    setLastCardNumberError(false);

    if (encodedExpiryDateMonth.length < 2 || encodedExpiryDateYear.length < 2) {
      setExpirationDateError(true);
      openInputError();
      return;
    }

    setExpirationDateError(false);

    if (encodedCVC.length < 3) {
      setCvccvvError(true);
      openInputError();
      return;
    }
    setCvccvvError(false);

    // if (email === '') {
    //   setEmailError(true);
    //   openModal(ErrorModal, {
    //     message: t('econtext_email_input_error'),
    //   });
    //   return;
    // }
    // setEmailError(false);

    // 이메일 validation
    if (email !== '') {
      if (!checkEmail(email)) {
        setEmailError(true);
        openModal(ErrorModal, {
          message: t('check_email_format'),
        });
        return;
      }
    }
    setEmailError(false);

    // if (address === '') {
    //   setAddressError(true);
    //   openBillingError();
    //   return;
    // }
    // setAddressError(false);

    // if (city === '') {
    //   setCityError(true);
    //   openBillingError();
    //   return;
    // }
    // setCityError(false);

    // if (country === '') {
    //   setCountryError(true);
    //   openBillingError();
    //   return;
    // }
    // setCountryError(false);

    // if (zipCode === '') {
    //   setZipCodeError(true);
    //   openBillingError();
    //   return;
    // }
    // setZipCodeError(false);

    // if (state === '') {
    //   setStateError(true);
    //   openBillingError();
    //   return;
    // }
    // setStateError(false);

    // if (phoneNum === '') {
    //   setPhoneNumError(true);
    //   openModal(ErrorModal, {
    //     message: t('econtext_tel_no_input_error'),
    //   });
    //   return;
    // }
    // setPhoneNumError(false);

    if (!agreeCheck) {
      setAgreeCheckError(true);
      openModal(ErrorModal, {
        message: t('error_agree_check'),
      });
      foucsTerms.current?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    setAgreeCheckError(false);

    if (isPaymentTokenExpired()) {
      // token expired
      navigate('/paymentExpired');

      return;
    }

    const credit3DsBody: Credit3DsRequest = {
      mid: paymentState.mid,
      authorization: `Bearer ${paymentState.auth}`,
      clientKey: paymentState.clientKey,
      reqDate: paymentState.reqDate,
      orderId: paymentState.orderId,
      productName: paymentState.productName,
      currency: paymentState.requestCurrency,
      amount: paymentState.requestAmount,
      cardNumber: {
        firstCardNumber: cardNumber,
        encSecondCardNumber: encryptedFirstCardNumber,
        encThirdCardNumber: encryptedSecondCardNumber,
        lastCardNumber: lastCardNumber,
      },
      cardMonth: encodedExpiryDateMonth,
      cardYear: encodedExpiryDateYear,
      cardCvv: encodedCVC,
      keypadToken: keypadToken,
      // cardHolder: `${familyName} ${name}`,
      cardHolder: ``,
      firstName: name,
      lastName: familyName,
      email: email,
      telNo: phoneNum,
      address: address,
      zip: zipCode,
      city: city,
      country: country,
      state: state,
      displayType: 'UI',
      webhookUrl: paymentState.webhookUrl,
      returnUrl: paymentState.returnUrl,
      sign: paymentState.sign,
      tid: paymentState.tid,
      mallReserverd: paymentState.mallReserved,
      billkeyReq: paymentState.billkeyReq,
    };
    if (schemeCode === 'UNIONPAY') credit3DsBody.schemeCode = 'UNIONPAY';
    setCredit3DsRequestBody(credit3DsBody);
    setLoading(true);

    if (isMobile) {
      navigate('/formSubmit?schemeGroup=credit', {
        state: { formData: credit3DsBody },
      });
    } else {
      const popup = window.open(
        '/formSubmit?schemeGroup=credit',
        '_blank',
        'width=700, height=850',
      );
      setPopup(popup);
      if (popup) {
        setTimeout(() => {
          popup?.postMessage(
            { eventType: 'formData', data: credit3DsBody },
            window.location.origin,
          );
        }, 1000);
      }
      checkPopupTimer = setInterval(checkPopupClosed, 1000, popup);
    }
  };

  function checkPopupClosed(popup) {
    if (popup && popup.closed) {
      clearInterval(checkPopupTimer);
      const ErrorKey = window.sessionStorage.getItem('isError');
      if (ErrorKey !== 'true') {
        transactResult.mutate();
      }
    }
  }

  return (
    <>
      <div className="tab">
        <div
          ref={refs.tab1Ref}
          id="tab-1"
          className="tab-on current"
          style={{
            height: isGlobal
              ? isMobileSize
                ? 'calc((var(--vh, 1vh) * 100) - 414px)'
                : 184
              : isMobileSize
              ? 'calc((var(--vh, 1vh) * 100) - 348px)'
              : 250,
          }}
        >
          <div className="form first">
            <div className="title">{t('card_info_title')}</div>
            <ul className="depth-1">
              <li
                className="input"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginBottom: 10,
                  gap: 6,
                }}
              >
                {brandList && brandList.length > 0 && (
                  <>
                    {(brandList.includes('VISA') ||
                      brandList.includes('MASTER') ||
                      brandList.includes('JCB')) && (
                      <button
                        type="button"
                        onClick={() => setSelectCard('others')}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 8,
                          padding: '12px 16px',
                          borderRadius: 8,
                          border:
                            selectCard === 'others'
                              ? '2px solid #0070f3'
                              : '1px solid #ccc',
                          backgroundColor:
                            selectCard === 'others' ? '#eef6ff' : 'transparent',
                          cursor: 'pointer',
                          height: 40,
                        }}
                      >
                        {brandList.includes('VISA') && (
                          <img
                            src={findImage('CreditCard-VISA-new.png')}
                            alt="VISA"
                            style={{
                              height: 38,
                              width: 38,
                              objectFit: 'contain',
                            }}
                          />
                        )}
                        {brandList.includes('MASTER') && (
                          <img
                            src={findImage('CreditCard-Master.png')}
                            alt="MASTER"
                            style={{
                              height: 38,
                              width: 38,
                              objectFit: 'contain',
                            }}
                          />
                        )}
                        {brandList.includes('JCB') && (
                          <img
                            src={findImage('CreditCard-JCB.png')}
                            alt="JCB"
                            style={{
                              height: 38,
                              width: 38,
                              objectFit: 'contain',
                            }}
                          />
                        )}
                      </button>
                    )}

                    {brandList.includes('AMEX') && (
                      <button
                        type="button"
                        onClick={() => setSelectCard('amex')}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '6px 12px',
                          borderRadius: 8,
                          border:
                            selectCard === 'amex'
                              ? '2px solid #0070f3'
                              : '1px solid #ccc',
                          backgroundColor:
                            selectCard === 'amex' ? '#eef6ff' : 'transparent',
                          cursor: 'pointer',
                          height: 40,
                        }}
                      >
                        <img
                          src={findImage('CreditCard-AMEX.png')}
                          alt="AMEX"
                          style={{
                            height: 38,
                            width: 38,
                            objectFit: 'contain',
                          }}
                        />
                      </button>
                    )}

                    {brandList.includes('UNIONPAY') && (
                      <button
                        type="button"
                        onClick={() => {
                          setSelectCard('unionpay');
                          setSchemeCode('UNIONPAY');
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '6px 12px',
                          borderRadius: 8,
                          border:
                            selectCard === 'unionpay'
                              ? '2px solid #0070f3'
                              : '1px solid #ccc',
                          backgroundColor:
                            selectCard === 'unionpay'
                              ? '#eef6ff'
                              : 'transparent',
                          cursor: 'pointer',
                          height: 40,
                        }}
                      >
                        <img
                          src={findImage('CreditCard-Union.png')}
                          alt="UnionPay"
                          style={{
                            height: 38,
                            width: 38,
                            objectFit: 'contain',
                          }}
                        />
                      </button>
                    )}
                  </>
                )}
              </li>
              <div
                style={{
                  fontSize: '14px',
                  color: '#8a9db4',
                  marginBottom: '5px',
                }}
                className="sub-title"
              >
                {t('card_number')}
                <span className="redstar">*</span>
              </div>
              <li style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div
                  className={isCardNumberError ? 'input error' : 'input'}
                  style={{ width: '22%', float: 'left', order: 1 }}
                >
                  <a></a>
                  <input
                    id="card"
                    name="text"
                    type="text"
                    inputMode="numeric"
                    maxLength={4}
                    placeholder={'0000'}
                    onChange={onChangeCardNumber}
                    onFocus={focusCardNumber}
                    value={cardNumber}
                  />
                </div>
                <KeyPad
                  identifier={'firstKeypad'}
                  setStateFunction={setEncryptedFirstCardNumber}
                  isError={isEncryptedFirstCardNumberError}
                  setError={setEncryptedFirstCardNumberError}
                  textLength="4"
                  placeholderText="0000"
                  css={{
                    width: '22%',
                    float: 'left',
                    marginLeft: '4%',
                    order: '2',
                  }}
                  keypadToken={keypadToken}
                />
                <KeyPad
                  identifier={'secondKeypad'}
                  setStateFunction={setEncryptedSecondCardNumber}
                  isError={isEncryptedSecondCardNumberError}
                  setError={setEncryptedSecondCardNumberError}
                  textLength="4"
                  placeholderText="0000"
                  css={{
                    width: '22%',
                    float: 'left',
                    marginLeft: '4%',
                    order: '3',
                  }}
                  keypadToken={keypadToken}
                />
                <div
                  className={
                    isLastCardNumberError
                      ? 'input lastCardNumber error'
                      : 'input lastCardNumber'
                  }
                  style={{
                    width: '22%',
                    float: 'left',
                    marginLeft: '4%',
                    order: 4,
                  }}
                >
                  <a></a>
                  <input
                    id="lastCardNumber"
                    name="text"
                    type="text"
                    inputMode="numeric"
                    enterKeyHint="done"
                    maxLength={6}
                    minLength={3}
                    placeholder={'000000'}
                    onChange={onChangeLastCardNumber}
                    value={lastCardNumber}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        (e.target as HTMLInputElement).blur();

                        const nextRef = document.querySelectorAll(
                          'div.input.expiryDateMonth',
                        )[0].children[1] as HTMLElement;
                        if (nextRef) {
                          nextRef.focus();
                          nextRef.click();
                        }
                        if (refs.tab1Ref.current) {
                          refs.tab1Ref.current.scrollTop = 160;
                        }
                      }
                    }}
                  />
                </div>
                {(isCardNumberError || isLastCardNumberError) && (
                  <div style={{ order: 5 }} className="error-text">
                    {t('invalid_card_error_text')}
                  </div>
                )}
              </li>
            </ul>
            <ul className="depth-2">
              <li>
                <div className="sub-title">
                  {t('expiration_date')}
                  <span className="redstar">*</span>
                </div>
                <div style={{ display: 'flex' }}>
                  <KeyPad
                    identifier={'expiryDateMonth'}
                    setStateFunction={setEncodedExpiryDateMonth}
                    placeholderText="MM"
                    textLength="2"
                    isError={isExpirationDateError}
                    setError={setExpirationDateError}
                    css={{ width: '45%' }}
                    // ref={expiryDateKey}
                    keypadToken={keypadToken}
                  />
                  <KeyPad
                    identifier={'expiryDateYear'}
                    setStateFunction={setEncodedExpiryDateYear}
                    placeholderText="YY"
                    textLength="2"
                    isError={isExpirationDateError}
                    setError={setExpirationDateError}
                    css={{ width: '45%', marginLeft: '10%' }}
                    // ref={expiryDateKey}
                    keypadToken={keypadToken}
                  />
                </div>
              </li>
              <li>
                <div className="sub-title">
                  {t('cvc/cvv')}
                  <span className="redstar">*</span>
                  <div className="tooltip">
                    <img
                      src={process.env.PUBLIC_URL + '/image/common/tooltip.png'}
                    />
                    <div className="tooltip-popup">{t('cvc/cvv_tooltip')}</div>
                  </div>
                </div>
                <KeyPad
                  identifier={'cvc'}
                  setStateFunction={setEncodedCVC}
                  placeholderText=""
                  textLength={selectCard === 'amex' ? '4' : '3'}
                  isError={isCvccvvError}
                  setError={setCvccvvError}
                  css={{ width: '100%' }}
                  keypadToken={keypadToken}
                />
              </li>
            </ul>
          </div>
          <div className="mailing">
            <div className="title">{t('payment_confirm_email_opt')}</div>
            <div className={isEmailError ? 'input error' : 'input'}>
              <input
                name="email"
                type="email"
                onChange={e => setEmail(e.target.value)}
                value={email}
              />
            </div>
          </div>
          {/* <div className="form">
            <div className="title">{t('billing_address_opt')}</div>
            <ul className="depth-1">
              <li>
                <div className="sub-title">
                  {t('address')}
                  <span className="redstar">*</span>
                </div>
                <div className={isAddressError ? 'input error' : 'input'}>
                  <input
                    id="address"
                    name="text"
                    value={address}
                    type="text"
                    onChange={e => setAddress(e.target.value)}
                  />
                </div>
              </li>
            </ul>
            <ul className="depth-2">
              <li>
                <div className="sub-title">
                  {t('city')}
                  <span className="redstar">*</span>
                </div>
                <div className={isCityError ? 'input error' : 'input'}>
                  <input
                    name="text"
                    type="text"
                    value={city}
                    onChange={e => setCity(e.target.value)}
                  />
                </div>
              </li>
              <li>
                <div className="sub-title">
                  {t('country')}
                  <span className="redstar">*</span>
                </div>
                <div className={isCountryError ? 'input error' : 'input'}>
                  <ReactSelect
                    className="user-info-select-country"
                    classNamePrefix="user-info-select-country_"
                    options={countryList}
                    placeholder={t('selectCountry')}
                    onChange={e => {
                      if (e) setCountry(e.value);
                    }}
                  />
                </div>
              </li>
            </ul>
            <ul className="depth-2">
              <li>
                <div className="sub-title">
                  {t('zip_code')}
                  <span className="redstar">*</span>
                </div>
                <div className={isZipCodeError ? 'input error' : 'input'}>
                  <input
                    name="text"
                    type="text"
                    value={zipCode}
                    onChange={e => {
                      const value = e.target.value;
                      //숫자 외 입력 못하도록 변경
                      const isNumber = checkNumber(Number(value.slice(-1)));
                      if (isNumber) {
                        setZipCode(e.target.value);
                      }
                    }}
                  />
                </div>
              </li>
              <li>
                <div className="sub-title">
                  {t('state')}
                  <span className="redstar">*</span>
                </div>
                <div className={isStateError ? 'input error' : 'input'}>
                  <input
                    name="text"
                    type="text"
                    value={state}
                    onChange={e => setState(e.target.value)}
                  />
                </div>
              </li>
            </ul>
            <ul className="depth-1">
              <li>
                <div className="sub-title">
                  {t('phone_num')}
                  <span className="redstar">*</span>
                </div>
                <div className={isPhoneNumError ? 'input error' : 'input'}>
                  <input
                    name="phone"
                    type="text"
                    value={phoneNum}
                    onChange={e => setPhoneNum(e.target.value)}
                  />
                </div>
              </li>
            </ul>
          </div> */}
          {iSBillInfoFormActive === false ? (
            <div className="c-section">
              <div className="box">
                <button
                  className="billing-button darkgray"
                  onClick={e => clickMoreButton(e)}
                >
                  {t('more')}▼
                </button>
              </div>
            </div>
          ) : (
            <div className="form">
              <div className="title">{t('billing_address_opt')}</div>
              <ul className="depth-1">
                <li>
                  <div className="sub-title">{t('address')}</div>
                  <div className="input">
                    <input
                      id="address"
                      name="text"
                      value={address}
                      type="text"
                      onChange={e => setAddress(e.target.value)}
                    />
                  </div>
                </li>
              </ul>
              <ul className="depth-2">
                <li>
                  <div className="sub-title">{t('city')}</div>
                  <div className="input">
                    <input
                      name="text"
                      type="text"
                      value={city}
                      onChange={e => setCity(e.target.value)}
                    />
                  </div>
                </li>
                <li>
                  <div className="sub-title">{t('country')}</div>
                  <div className="input">
                    <ReactSelect
                      className="user-info-select-country"
                      classNamePrefix="user-info-select-country_"
                      options={countryList}
                      placeholder={t('selectCountry')}
                      onChange={e => {
                        if (e) setCountry(e.value);
                      }}
                    />
                  </div>
                </li>
              </ul>
              <ul className="depth-2">
                <li>
                  <div className="sub-title">{t('zip_code')}</div>
                  <div className={'input'}>
                    <input
                      name="text"
                      type="text"
                      value={zipCode}
                      onChange={e => {
                        // const value = e.target.value;
                        // //숫자 외 입력 못하도록 변경
                        // const isNumber = checkNumber(Number(value.slice(-1)));
                        // if (isNumber) {
                        setZipCode(e.target.value);
                        // }
                      }}
                    />
                  </div>
                </li>
                <li>
                  <div className="sub-title">{t('state')}</div>
                  <div className="input">
                    <input
                      name="text"
                      type="text"
                      value={state}
                      onChange={e => setState(e.target.value)}
                    />
                  </div>
                </li>
              </ul>
              <ul className="depth-1">
                <li>
                  <div className="sub-title">{t('phone_num')}</div>
                  <div className="input">
                    <input
                      name="phone"
                      type="text"
                      value={phoneNum}
                      onChange={e => {
                        let value = e.target.value;
                        if (numberPattern.test(value)) {
                          const onlyNumbers = e.target.value.replace(
                            /[^0-9]/g,
                            '',
                          );
                          setPhoneNum(onlyNumbers);
                        }
                      }}
                    />
                  </div>
                  <div className="label">
                    <div className="text caution-text">
                      {t('phone_num_option_caution')}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          )}
          {iSBillInfoFormActive && (
            <div className="c-section">
              <div className="box">
                <button
                  className="billing-button darkgray"
                  onClick={e => clickFoldButton(e)}
                >
                  {t('fold')}▲
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="agreeFloatBox">
        <div className="label" ref={foucsTerms}>
          <div className="check">
            <input
              type="checkbox"
              id={AgreeCheckError ? 'checkbox error' : 'checkbox'}
              name="agree"
              checked={agreeCheck}
              onChange={e => {
                setAgreeCheck(e.target.checked);
              }}
            />

            <label
              htmlFor={AgreeCheckError ? 'checkbox error' : 'checkbox'}
            ></label>
          </div>
          <div className="columnBox">
            <div className="text">
              <div
                onClick={() => setAgreeCheck(!agreeCheck)}
                style={{ cursor: 'pointer' }}
              >
                {t('start_agree_terms')}
                {t('terms_and_conditions')}
                {t('and_the')}
                {t('privacy_policy')}
                {t('end_agree_terms')}
              </div>
              <img
                className={`arrow ${open ? 'open' : ''}`}
                src={ArrowPng}
                alt=""
                onClick={() => setOpen(!open)}
              />
            </div>
            <div className={`text toggleRow ${open ? 'open' : ''}`}>
              <p className="dot">●</p>
              <span
                className="link"
                onClick={() => handleTermsOrPrivacy('SERVICE')}
              >
                {t('terms_and_conditions')}
              </span>
            </div>
            <div className={`text toggleRow ${open ? 'open' : ''}`}>
              <p className="dot">●</p>
              <span
                className="link"
                onClick={() => handleTermsOrPrivacy('PRIVACY')}
              >
                {t('privacy_policy')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="c-section">
        <div className="box">
          {isUnique ? (
            <button className="all-close" onClick={handleClosed}>
              {t('cancel')}
            </button>
          ) : (
            <button className="all-close" onClick={previous}>
              {t('previous')}
            </button>
          )}
          <button
            className="orange"
            onClick={clickPay}
            onKeyDown={e => handleKeyDown(e)}
          >
            {t('pay_now')}
          </button>
        </div>
      </div>
    </>
  );
};

export default Credit3DsForm;
